import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { Layout } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";

const OUTBOUND_LINKS: Record<string, { label: string; url: string }> = {
  powerball: { label: "Powerball Official Site", url: "https://www.powerball.com" },
  "mega-millions": { label: "Mega Millions Official Site", url: "https://www.megamillions.com" },
  "lucky-for-life": { label: "Lucky for Life", url: "https://www.luckyforlife.us" },
  "lotto-america": { label: "Lotto America", url: "https://www.lottoamerica.com" },
  cash4life: { label: "Cash4Life", url: "https://www.cash4life.com" },
  "responsible-gaming": { label: "National Council on Problem Gambling", url: "https://www.ncpgambling.org" },
};

export const Route = createFileRoute("/go/$linkId")({
  head: () => ({
    meta: [
      { title: "Redirecting — USA Lottery Club" },
      { name: "robots", content: "noindex,nofollow" },
    ],
  }),
  component: OutboundRedirect,
});

function OutboundRedirect() {
  const { linkId } = Route.useParams();
  const target = OUTBOUND_LINKS[linkId];

  useEffect(() => {
    if (target && typeof window !== "undefined") {
      const t = setTimeout(() => window.location.replace(target.url), 1200);
      return () => clearTimeout(t);
    }
  }, [target]);

  return (
    <Layout>
      <div className="container py-16 max-w-xl text-center">
        {target ? (
          <>
            <h1 className="font-display text-2xl font-bold mb-2">Redirecting to {target.label}…</h1>
            <p className="text-muted-foreground mb-6">You are leaving USA Lottery Club.</p>
            <Button asChild>
              <a href={target.url} rel="noopener noreferrer">
                <ExternalLink className="h-4 w-4 mr-2" /> Continue
              </a>
            </Button>
          </>
        ) : (
          <>
            <h1 className="font-display text-2xl font-bold mb-2">Link not found</h1>
            <p className="text-muted-foreground">This outbound link is no longer available.</p>
          </>
        )}
      </div>
    </Layout>
  );
}